// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  font-size: 52px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  color: #6060ab;
  font-weight: 500;
}

.arrow {
  text-align: left;
}

.entry {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.tool-card {
  width: 560px;
  height: 220px;
  margin-left: auto;
  margin-right: auto;
  background: linear-gradient(45deg, #acb6e5 10%, #86fde8 100%);
  border-radius: 10px;
  padding: 3px 3px;
}

.content {
  width: 554px;
  height: 213px;
  margin-left: auto;
  margin-right: auto;
  background-color: white; /* Background color of the inner content */
  border-radius: 8px; /* Slightly smaller radius for inner content */
  padding: 25px 40px;
}

.btn {
  margin-top: 6px;
  background-color: #39393b;
  border: 1px solid #39393b;
  padding-top: 2px;
  padding-bottom: 2px;
  cursor: pointer;
}

.btn:hover {
  background-color: #6060ab;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19);
  transition-duration: 0.3s;
}

.tool-icon {
  font-size: 38px;
  margin-left: 15px;
  display: inline-block;
  color: #1f1f1f;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/app/features/digital-identity/digital-identity-tools/digital-identity-tools.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,aAAA;EAEA,mBAAA;EACA,WAAA;AADF;;AAKA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA,EAAA,0CAAA;EACA,kBAAA,EAAA,8CAAA;EACA,kBAAA;AAFF;;AAKA;EACE,eAAA;EAEA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAHF;;AAMA;EACE,yBAAA;EACA,+EAAA;EAEA,yBAAA;AAJF;;AAOA;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;AAJF","sourcesContent":[".heading {\r\n  font-size: 52px;\r\n  //margin-top: 70px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  text-align: center;\r\n  color: #6060ab;\r\n  font-weight: 500;\r\n}\r\n\r\n.arrow {\r\n  text-align: left;\r\n}\r\n\r\n.entry {\r\n  display: flex;\r\n\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  //padding:0.10rem;\r\n}\r\n\r\n.tool-card {\r\n  width: 560px;\r\n  height: 220px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  background: linear-gradient(45deg, #acb6e5 10%, #86fde8 100%);\r\n  border-radius: 10px;\r\n  padding: 3px 3px;\r\n}\r\n\r\n.content {\r\n  width: 554px;\r\n  height: 213px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  background-color: white; /* Background color of the inner content */\r\n  border-radius: 8px; /* Slightly smaller radius for inner content */\r\n  padding: 25px 40px;\r\n}\r\n\r\n.btn {\r\n  margin-top: 6px;\r\n  // margin-left:110px;\r\n  background-color: #39393b;\r\n  border: 1px solid #39393b;\r\n  padding-top: 2px;\r\n  padding-bottom: 2px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn:hover {\r\n  background-color: #6060ab;\r\n  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.24),\r\n    0 17px 50px 0 rgba(0, 0, 0, 0.19);\r\n  transition-duration: 0.3s;\r\n}\r\n\r\n.tool-icon {\r\n  font-size: 38px;\r\n  margin-left: 15px;\r\n  display: inline-block;\r\n  color: #1f1f1f;\r\n  text-decoration: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
